import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AbstractIdEmailMessage, ThesesResource, ThesesService } from 'src/app/services/data/theses.service';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import { catchError, tap } from 'rxjs/operators';
import { MessageToastService } from '../../services/common/message-toast.service';

@UntilDestroy()
@Component({
  selector: 'app-theses-done',
  templateUrl: './theses-done.component.html',
  styleUrls: ['./theses-done.component.css']
})
export class ThesesDoneComponent implements OnInit {

  isFormReady = false;
  private _alias: string;
  thesesResource: ThesesResource;

  constructor(
    private router: Router,
    private _route: ActivatedRoute,
    private thesesService: ThesesService,
    private msg: MessageToastService
    ) {
      this.thesesResource = thesesService.getTheses();
    }

  ngOnInit(): void {

    this.isFormReady = false;

    this._route.paramMap.pipe(
      untilDestroyed(this),
      tap(data =>  this._alias = data.get('alias'))
    ).subscribe();

    console.log(this.thesesResource);

    if (this.thesesResource?.mainAuthor === null){
      this.router.navigate(['/theses', this._alias]);
    }

    this.isFormReady = true;
  }

  sendData() {

    if (this.thesesResource.mainAuthor.middleName === null) {
      this.thesesResource.mainAuthor.middleName = '';
    }
    if (this.thesesResource.mainAuthor.contactEmail === null) {
      this.thesesResource.mainAuthor.contactEmail = '';
    }
    if (this.thesesResource.mainAuthor.workplace === null) {
      this.thesesResource.mainAuthor.workplace = '';
    }

    this.thesesService.registrationTheses(this._alias).toPromise()
    .then((data: AbstractIdEmailMessage) => {
      if (data) {
        this.thesesService.thesesResult = new AbstractIdEmailMessage(data.id, data.emailMessage);
        this.router.navigate(['/theses', this._alias, 'end-message']);
      }
    })
    .catch(err => this.msg.error(err))
    ;

    // this.thesesService.registrationTheses(this._alias).pipe(
    //   untilDestroyed(this),
    //   catchError(err => {
    //     console.log(err);
    //     this.msg.error(err);
    //     return [];
    //   }),
    //   tap(data => {
    //     this.router.navigate(['/theses', this._alias, 'end-message']);
    //   })
    // ).subscribe();

    // console.log(this.thesesService.getTheses());
    // this.router.navigate(['/theses', this._alias, 'authors']);

  }

  prevPage() {
    this.router.navigate(['/theses', this._alias, 'theses-data']);
  }

}
